// Core
import { Component } from '@angular/core';

// Components
import { Navbar } from "../index-page/components/index-masterhead-section/components/navbar/navbar";

// Third-party Libraries
import dayjs from 'dayjs';
import { FooterSection } from "../shared/components/footer-section/footer-section";

@Component({
    standalone: true,
    selector: 'app-privacy-policy-page',
    imports: [Navbar, FooterSection],
    templateUrl: './privacy-policy-page.html',
    styleUrl: './privacy-policy-page.scss'
})
export class PrivacyPolicyPage {

    // Third-party Libraries
    dayjs = dayjs;

    // Variables
    lastUpdatedDate: string = dayjs("06/27/2026", "MM/DD/YYYY").format("DD MMMM YYYY HH:mm:ss");
}
